import { useRef } from 'react';

import { useLegalClientSaveIdentificationNumbers } from 'api/requests';
import { useServerErrorNotify } from 'hooks';
import { IdentificationNumbersFormType } from 'modules/onboarding/common/forms/identificationNumbersForm';

import { useOnboardingContext } from './useOnboardingContext';

export const useIdentificationNumbers = () => {
  const { goToBack, goToNext, data } = useOnboardingContext();

  const {
    saveIdentificationNumbers,
    loading: submitLoading,
    error,
  } = useLegalClientSaveIdentificationNumbers();

  const initialValues = useRef<IdentificationNumbersFormType>(
    data.legalClient?.identificationNumbers ?? {}
  ).current;

  const handleSubmit = async (values: IdentificationNumbersFormType) => {
    await saveIdentificationNumbers(data.legalClient!.id, values);
    goToNext();
  };

  useServerErrorNotify(error);

  return {
    onSubmit: handleSubmit,
    goToBack,
    initialValues,
    submitLoading,
  };
};
